<template>
	<div class="display-flex flex-justify-space-between on-boarding-step-wrapper">
		<div class="display-flex flex-column flex-justify-space-between">
			<div class="on-boarding-step-explanation-text">
				Ply is a very powerful tool. When possibilities are endless, it can be<br />overwhelming to decide what to build. Ply is built to
				deliver a big<br />impact in a short time, but that doesn’t necessarily mean you need<br />to start with your biggest project.<br /><br />Get
				some ideas for features you could build.
			</div>
			<div class="display-flex flex-row flex-align-center">
				<AnemicButton :disabled="isCompleted" @click="openVideoDialog" tile class="on-boarding-step-finish-step-button">
					Let's go
				</AnemicButton>
				<div v-if="!isCompleted" @click="markAsComplete" class="ml-6 mark-done on-boarding-step-explanation-text">Mark as done</div>
			</div>
		</div>
		<div class="iframe-container">
			<div v-if="isLoading" class="width-100 height-100 flex-centerize">
				<AppLoader size="18px" />
			</div>
			<div class="width-100" style="position: relative; padding-bottom: 56.25%; height: 0">
				<iframe
					frameborder="0"
					allowfullscreen
					:src="VIDEO_URL"
					mozallowfullscreen
					v-show="!isLoading"
					webkitallowfullscreen
					@load="isLoading = false"
					class="iframe-container rounded"
					style="top: 0; left: 0; width: 100%; height: 100%; position: absolute"
				/>
				<div @click="openVideoDialog" style="top: 0; left: 0; width: 100%; height: 100%; position: absolute" />
			</div>
		</div>
	</div>
</template>

<script>
const VIDEO_URL = 'https://www.loom.com/embed/71e689c160cf4babbb3f2cb018c35b60';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
export default {
	name: 'OnBoardingWhatsPossible',
	props: { stepDetails: { type: Object } },
	components: {},
	computed: {
		isCompleted() {
			return this.stepDetails.isCompleted;
		},
	},
	methods: {
		markAsComplete() {
			this.$emit('mark-step-as-done', this.stepDetails);
		},
		openVideoDialog() {
			this.markAsComplete();
			AppDialogManagerService.openIFrameDialog({ iframeUrl: this.VIDEO_URL });
		},
	},
	created() {},
	data() {
		return {
			VIDEO_URL,
			isLoading: true,
		};
	},
};
</script>

<style scoped lang="scss">
.iframe-container {
	height: 244px;
	overflow: hidden;
	border-radius: 16px;
	width: 430px !important;
	border: 1px solid #dfe4ef;
}
.mark-done {
	cursor: pointer;
	text-decoration: underline;
}
</style>
